import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight } from "react-icons/fi";
import Frame from "../shell/Frame";
import Meta from "../shell/Meta";
import Invite from "../parts/Invite";
import services, { getService } from "../content/services";

const Service = () => {
  const { slug } = useParams();
  const svc = getService(slug);
  if (!svc) return <Navigate to="/services" replace />;

  const others = services.filter((s) => s.slug !== slug).slice(0, 3);

  return (
    <Frame>
      <Meta title={svc.title} description={svc.blurb} />

      <section className="svc-hero">
        <div className="shell">
          <div className="crumb">
            <Link to="/">~</Link><span className="sep">/</span>
            <Link to="/services">services</Link><span className="sep">/</span>
            {svc.slug}
          </div>
          <span className="eyebrow">{svc.code} · Capability</span>
          <h1>{svc.title}</h1>
          <p className="lede">{svc.intro}</p>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="svc-body">
            <div className="prose">
              {svc.body.map((p, i) => <p key={i}>{p}</p>)}
              <div style={{ marginTop: "2.25rem" }}>
                <Link to="/contact" className="btn btn--mint">
                  Discuss this discipline <FiArrowRight />
                </Link>
              </div>
            </div>

            <aside>
              <div className="panel">
                <h4>What's included</h4>
                <ul className="tick">
                  {svc.deliverables.map((d, i) => (
                    <li key={i}>
                      <span className="m" />
                      <span>{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>

          <div className="also">
            <div className="section-head">
              <div className="left">
                <span className="eyebrow">Also relevant</span>
                <h2 style={{ fontSize: "1.7rem" }}>Disciplines often combined.</h2>
              </div>
            </div>
            <div className="caps">
              {others.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} className="cap">
                  <div className="code">{s.code}</div>
                  <h3>{s.title}</h3>
                  <p>{s.blurb}</p>
                  <span className="more">READ MORE <FiArrowUpRight /></span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Invite />
    </Frame>
  );
};

export default Service;
